import React from "react";
import ContactCard from "./ContactCard";
import WriteToUs from "./WriteToUs";
import TicketOverview from "./TicketOverview";

function ClientSupport() {
  return (
    <>
      <div
        className="tab-pane fade show active client"
        id="pills-client"
        role="tabpanel"
        aria-labelledby="pills-client-tab"
      >
        {/* contact card */}
        <ContactCard />
        <div className="support-write-overview">
          {/* writes to us */}
          <div className="writes-to-us">
            <WriteToUs />
          </div>
          {/* tickets overview */}
          {/* <div className="tickets-overview col-sm-12 col-md-12 col-lg-6">
            <TicketOverview />
          </div> */}
        </div>
      </div>
    </>
  );
}
export default ClientSupport;
